import React from 'react'
import HeroSection from '../components/HeroSection'
import AboutIn from '../components/Homepage/AboutIn'
import Projects from '../components/Homepage/Projects'
import AppShowcase from '../components/Homepage/AppShowcase'
import Service from '../components/Homepage/Service'
import ContentUs from '../components/Homepage/ContentUs'

const Index = () => {
     return (
          <div>
               <HeroSection />
               <AboutIn />
               <Projects />
               <AppShowcase />
               <Service />
               <ContentUs/>
          </div>
     )
}

export default Index

